<div class="countdown-timer" *ngIf="timeLeft.total > 0">
  <div class="countdown-content">
    <div class="brand-section">
      <div class="brand-logo">
        <img src="./assets/imgs/bpm-arena-icon/bpm-arena.png" alt="BPM Arena" class="brand-logo-img">
      </div>
      <div class="countdown-label">BPM Arena Sale Ends in</div>
    </div>
    
    <div class="countdown-display">
      <div class="time-unit" *ngIf="showDays && timeLeft.days !== '00'">
        <span class="time-value">{{ timeLeft.days }}</span>
        <span class="time-label">DAYS</span>
      </div>
      <div class="time-separator" *ngIf="showDays && timeLeft.days !== '00'">|</div>
      
      <div class="time-unit">
        <span class="time-value">{{ timeLeft.hours }}</span>
        <span class="time-label">HOURS</span>
      </div>
      <div class="time-separator">|</div>
      
      <div class="time-unit">
        <span class="time-value">{{ timeLeft.minutes }}</span>
        <span class="time-label">MINUTES</span>
      </div>
      <div class="time-separator">|</div>
      
      <div class="time-unit">
        <span class="time-value">{{ timeLeft.seconds }}</span>
        <span class="time-label">SECONDS</span>
      </div>
    </div>
  </div>
  
  <button class="action-button" (click)="navigateToBpmArena()">AVAIL OFFER!</button>
</div>

<div class="countdown-expired" *ngIf="timeLeft.total <= 0">
  <span class="expired-message">Sale Ended</span>
</div>